* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: 616px;
  width: 870px;
}

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .credentials-patch {
    display: flex;
    margin-bottom: calc(var(--spacer) * 2.5);
    gap: calc(var(--spacer) * 10 + 3px);

    justify-content: flex-start;
    align-items: center;

    #user-input,
    #password-input,
    #description-input {
      flex: 0;
      margin-right: var(--spacer);
    }

    #credentials-boxes {
      display: flex;
      justify-content: flex-start;
      //align-items: center;
      gap: calc(var(--spacer) * 2);
    }
  }
}

gz-info-box {
  padding: calc(2 * var(--spacer)) 0 0;
  line-height: 18px;
  --info-box-max-width: 870px;
}

.info-box-style::part(container) {
  padding: unset;
  width: 870px;
}

.form-field-input {
  width: var(--form-field-label-width);
  margin-top: calc(var(--spacer) * 1.5);
}

#add-button {
  display: inline;
}

#no-results-subtitle {
  margin: 0;
  font-size: var(--body-size-medium);
  color: var(--body-text-arrows-400);
}

.hidden {
  display: none;
}

#size-helper-wrapper {
  color: var(--body-text-arrows-400);
  font-size: var(--body-size);
  padding: 0 var(--spacer);

  transition: opacity 100ms ease-in-out, transform 200ms ease-out;

  pointer-events: none;
  transform-origin: top;
  height: 14px;
  transform: translateY(0) scaleY(1);
  margin-top: calc(var(--spacer) / 2);
  opacity: 1;

  p {
    font-family: var(--font-family-secondary);
    margin: 0;
  }
}
